export default __webpack_public_path__ + "static/media/line.c5f0eaa3.svg";